export default __webpack_public_path__ + "static/media/android-apple-apps.39c11516.svg";